import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import {formatPatientName} from '../../helpers/patients';
import {
  formatSessionDate,
  formatSessionTime,
  formatSessionTitle,
  getSessionCategory,
} from '../../helpers/sessions';
import CaseSummary from '../cases/CaseSummary';

const SessionSummary = props => {
  const {session: s} = props;
  return (
    <Box sx={{ backgroundColor: config().colors.background, padding: '0.8rem'}}>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Stack direction='row' alignItems='center' spacing={2} marginBottom={1}>
            <Typography variant='body' color='text.light'>
              Patient:
            </Typography>
            <Typography variant='body'>
              {formatPatientName(s.patient)}
            </Typography>
          </Stack>
          <Stack direction='row' alignItems='center' spacing={2} marginBottom={1}>
            <Typography variant='body' color='text.light'>
              Session Date:
            </Typography>
            <Typography variant='body'>
              {formatSessionDate(s)}
            </Typography>
          </Stack>
          <Stack direction='row' alignItems='center' spacing={2} marginBottom={1}>
            <Typography variant='body' color='text.light'>
              Session Time:
            </Typography>
            <Typography variant='body'>
              {formatSessionTime(s)}
            </Typography>
          </Stack>
          <Stack direction='row' alignItems='center' spacing={2} marginBottom={1}>
            <Typography variant='body' color='text.light'>
              Note Type:
            </Typography>
            <Typography variant='body'>
              {getSessionCategory(s)}
            </Typography>
          </Stack>
          <Stack direction='row' alignItems='center' spacing={2}>
            <Typography variant='body' color='text.light'>
              Session Type:
            </Typography>
            <Typography variant='body'>
              {formatSessionTitle(s)}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack>
            <CaseSummary 
              case={s.case}
              session={s}
              showBillingInstructions={props.showBillingInstructions}
            />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

SessionSummary.propTypes = {
  session: PropTypes.object,
};

export default SessionSummary;
